<template>
    <select
        :id="id"
        :name="name"
        class="input"
        :class="{TA:isTestAchat, unit:unit}"
        v-bind:value="value"
        :disabled="disabled"
        @change="update($event.target.value)">
        <slot v-if="Object.keys($slots).length"></slot>
        <option
            v-else
            v-for="option in options"
            :data-selected="option === value"
            :key="option"
            v-bind:value="option">
            {{ option }}
        </option>
    </select>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        type: {
            type: String
        },
        id: {
            type: String
        },
        name: {
            type: String
        },
        options: {
            type: Array
        },
        disabled: {
            type: Boolean
        },
        unit: {
            type: Boolean,
            default: false
        },
        value: [Number, String]
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/SelectField.vue